import { Button, Tooltip } from 'antd';
import L from 'leaflet';
import React, { useEffect, useRef, useState } from 'react';

import 'leaflet.awesome-markers/dist/leaflet.awesome-markers.css';
import 'leaflet.awesome-markers/dist/leaflet.awesome-markers.js';
import '@fortawesome/fontawesome-free/css/all.css';

const DrawButtons = ({ mapRef }) => {
  const [showSubmenu, setShowSubmenu] = useState(false);
  const drawnItemsRef = useRef(new L.FeatureGroup());
  const drawControlRef = useRef(new L.Control.Draw({
    draw: {
      marker: {
        icon: L.AwesomeMarkers.icon({
          icon: 'fa-duotone fa-location-dot',
          prefix: 'fa'
        })
      },
      polyline: true,
      polygon: true,
      circle: true,
      rectangle: false,
      circlemarker: false
    },
    edit: {
      featureGroup: drawnItemsRef.current
    }
  }));

  // ### DELETE THIS AND ONLY ADD IT WHEN NECESSARY? ###
  useEffect(() => {
    mapRef.current.addLayer(drawnItemsRef.current);
    mapRef.current.addControl(drawControlRef.current);
  }, []);

  const toggleSubmenu = () => {
    setShowSubmenu(!showSubmenu);
  };

  const enableDrawingMode = (mode) => {

    mapRef.current.on("draw:created", (event) => { // Handle draw event.

      const type = event.layerType;
      const layer = event.layer;
      drawnItemsRef.current.addLayer(layer);

      switch (type) {
        case 'polygon': {
          const area = L.GeometryUtil.geodesicArea(layer.getLatLngs()[0]);
          layer.bindPopup((area / 1000000).toFixed(2) + ' square kilometers');
          layer.openPopup();
          break;
        }
        case 'polyline': {
          layer.bindPopup((layer.getDistance()).toFixed(2) + ' kilometers');
          layer.openPopup();
          break;
        }
        case 'marker': {
          const latLng = layer.getLatLng();
          layer.bindPopup('Marker at latitude: ' + latLng.lat.toFixed(2) + ', longitude: ' + latLng.lng.toFixed(2));
          layer.openPopup();
          break;
        }
        case 'circle': {
          const radius = layer.getRadius();
          const latLng = layer.getLatLng();
          layer.bindPopup('Radius: ' + (radius / 1000).toFixed(2) + ' kilometers. </br> Center at latitude: ' + latLng.lat.toFixed(2) + ', longitude: ' + latLng.lng.toFixed(2));
          layer.openPopup();
          break;
        }
        default: break;
      }

    });

    const drawHandler = drawControlRef.current._toolbars.draw._modes[mode];
    if (drawHandler && drawHandler.handler) {
      drawHandler.handler.enable();
    } else {
      console.error(`Drawing mode "${mode}" not available.`);
    }
  };

  const isActive = showSubmenu ? "active" : ""; // We use it to save the className of the submenu.

  return (
    <div id='draw-buttons'>
      <Tooltip title="Drawing tools" placement='bottom'>
        <Button
          icon={<i className="fas fa-pen-ruler" style={{ color: 'white' }} />}
          onClick={(e) => {
            e.stopPropagation();
            toggleSubmenu();
          }}
        />
      </Tooltip>

      <div id='draw-submenu' className={isActive}>
        <Tooltip title="Marker" placement="left">
          <Button
            icon={<i className="fas fa-map-marker-alt" style={{ color: 'white' }} />}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = 'rgba(58, 113, 133, 0.6)'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#2e5969'}
            onClick={(e) => {
              e.stopPropagation();
              enableDrawingMode('marker');
              toggleSubmenu();
            }}
          />
        </Tooltip>

        <Tooltip title="Polygon" placement="left">
          <Button
            icon={<i className="fas fa-draw-polygon" style={{ color: 'white' }} />}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = 'rgba(58, 113, 133, 0.6)'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#2e5969'}
            onClick={(e) => {
              e.stopPropagation();
              enableDrawingMode('polygon');
              toggleSubmenu();
            }}
          />
        </Tooltip>

        <Tooltip title="Line" placement="left">
          <Button
            icon={<i className="fas fa-ruler" style={{ color: 'white' }} />}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = 'rgba(58, 113, 133, 0.6)'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#2e5969'}
            onClick={(e) => {
              e.stopPropagation();
              enableDrawingMode('polyline');
              toggleSubmenu();
            }}
          />
        </Tooltip>
        <Tooltip title="Circle" placement="left">
          <Button
            icon={<i className="fas fa-circle" style={{ color: 'white' }} />}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = 'rgba(58, 113, 133, 0.6)'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#2e5969'}
            onClick={(e) => {
              e.stopPropagation();
              enableDrawingMode('circle');
              toggleSubmenu();
            }}
          />
        </Tooltip>

        <Tooltip title="Delete" placement="left">
          <Button
            icon={<i className="fas fa-trash-can" style={{ color: 'white' }}></i>}
            onMouseOver={(e) => e.currentTarget.style.backgroundColor = 'rgba(231, 100, 123, 1)'}
            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#2e5969'}
            onClick={(e) => {
              e.stopPropagation();
              drawnItemsRef.current.clearLayers();
              toggleSubmenu();
            }}
          />
        </Tooltip>
      </div>
    </div>
  );
}

export default DrawButtons;